// Слова и числа для интерфейса: склонение после числа, даты, суммы, проверка ответов мастера.

export function plural(n: number, one: string, few: string, many: string): string {
  const rest = n % 100;
  const word = rest >= 11 && rest <= 19 ? many : rest % 10 === 1 ? one : rest % 10 >= 2 && rest % 10 <= 4 ? few : many;
  return `${n} ${word}`;
}

export const shortDate = (iso: string) => new Date(iso).toLocaleDateString("ru-RU", { day: "numeric", month: "short" });

// «5 000 ₽» не должно разрываться между строками: пробелы внутри сумм — неразрывные.
export const nb = (text: string) => text.replace(/(\d) (?=\d{3}(?!\d))/g, "$1 ").replace(/ ₽/g, " ₽");

export function chatGroup(iso: string, now = new Date()): string {
  const day = new Date(iso);
  day.setHours(0, 0, 0, 0);
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const ago = Math.round((today.getTime() - day.getTime()) / 86_400_000);
  return ago <= 0 ? "Сегодня" : ago === 1 ? "Вчера" : ago < 7 ? "На этой неделе" : ago < 31 ? "В этом месяце" : "Ранее";
}

export const MONEY_RE = /^\d[\d\s]*([.,]\d{1,2})?$/;
const DATE_RE = /^(\d{2})\.(\d{2})\.(\d{4})$/;
export const CHOICE_LABELS: Record<string, string> = { "м": "Мужчина", "ж": "Женщина" };
export const choiceLabel = (value: string) => CHOICE_LABELS[value] || value;

// kind: text | date | money | lines | block | checklist (флажки options и свои пункты — приложения).
export type Field = {
  key: string; question: string; kind: string; example: string; optional: boolean; choices: string[];
  default?: string | null; when?: string | null; options?: string[];
  legal?: boolean;                 // рассказ или доводы: помощник предложит юридическую формулировку
};

export function checkField(field: Field, value: string): string {
  if (!value) return field.optional ? "" : "Это поле нужно заполнить.";
  if (field.choices.length && !field.choices.includes(value)) return "Выберите один из вариантов.";
  if (field.kind === "date") {
    const m = value.match(DATE_RE);
    const d = m && new Date(+m[3], +m[2] - 1, +m[1]);
    if (!m || !d || d.getDate() !== +m[1] || d.getMonth() !== +m[2] - 1) return `Нужна дата в формате ДД.ММ.ГГГГ, например ${field.example}.`;
  }
  if (field.kind === "money" && !MONEY_RE.test(value)) return `Нужна сумма цифрами, например ${field.example}.`;
  return "";
}

// Число участников из ответа «Сколько ответчиков?»: не число — один.
export const countValue = (value: string | undefined) => (/^\d+$/.test((value || "").trim()) && +value! > 0 ? +value! : 1);

// Уточняющий вопрос задаём, только если заполнено основное поле (представитель) или участников не меньше N
// (when = "defendant_count>=2" — вопросы о втором ответчике).
export function relevant(field: Field, answers: Record<string, string>): boolean {
  if (!field.when) return true;
  const [key, number] = field.when.split(">=");
  if (number !== undefined) return countValue(answers[key]) >= Number(number);
  return Boolean((answers[field.when] || "").trim());
}

// Для сравнения значений из разных документов: без регистра, ё и знаков.
export const plain = (text: string) => text.toLowerCase().replace(/ё/g, "е").replace(/[^0-9a-zа-я]/g, "");
